var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C8.875 11 8 10.125 8 9C8 9 8 8.96875 8 8.9375C8.15625 8.96875 8.3125 9 8.5 9C9.3125 9 9.96875 8.34375 9.96875 7.53125C9.96875 7.34375 9.9375 7.1875 9.90625 7.03125C9.9375 7.03125 9.96875 7 10 7C11.0938 7 12 7.90625 12 9C12 10.125 11.0938 11 10 11ZM18.875 9.5625C18.9375 9.6875 18.9688 9.84375 18.9688 10.0312C18.9688 10.1875 18.9375 10.3438 18.875 10.4688C17.1875 13.7812 13.8125 16 10 16C6.15625 16 2.78125 13.7812 1.09375 10.4688C1.03125 10.3438 1 10.1875 1 10C1 9.84375 1.03125 9.6875 1.09375 9.5625C2.78125 6.25 6.15625 4 10 4C13.8125 4 17.1875 6.25 18.875 9.5625ZM10 5C7.78125 5.03125 6 6.8125 6 9C6 11.2188 7.78125 13 10 13C12.1875 13 14 11.2188 14 9C14 6.8125 12.1875 5 10 5ZM10 15C13.3438 15 16.4062 13.0938 18 10C17.0938 8.28125 15.6875 6.84375 13.9375 5.96875C14.5938 6.8125 15 7.875 15 9C15 11.7812 12.75 14 10 14C7.21875 14 5 11.7812 5 9C5 7.875 5.375 6.8125 6.03125 5.96875C4.28125 6.84375 2.875 8.28125 2 10C3.5625 13.0938 6.625 15 10 15Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.f1b929beb3def65d233e5128727f355f.svg";
export { ForwardRef as ReactComponent };